import { useMutation } from "@tanstack/react-query";
import { ordersClient } from "@core/clients";
import { TOrder } from "@core/types";
import { queryClient } from "../../config/query-client";

const useCancelOrderMutation = () => {
  return useMutation({
    mutationKey: ["order", "cancel"],
    mutationFn: async (orderId: string): Promise<Partial<TOrder>> => {
      return ordersClient.orderCancel(orderId);
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["orders"] });
      queryClient.invalidateQueries({ queryKey: ["order", data.id] });

      if (data.rewardPoints) {
        queryClient.invalidateQueries({ queryKey: ["get-profile", data.customer?.id] });
      }
    },
  });
};

export default useCancelOrderMutation;
